<template>
  <div v-if="showScore"
       :id="`kid-score-${well._id}`"
       class="kid-score well-card-option"
       :class="blastScoreColor">
    <span class="label">{{ blastScoreText }}</span>
  </div>

  <div v-else
       :id="`kid-score-${well._id}`"
       class="kid-score well-card-option na_score"

  >
    <span class="label">{{ noScoreText }}</span>


  </div>
</template>

<script>
import {mapGetters, mapState} from 'vuex'

const DEFAULT_BLAST_AT_HOUR = 68


export default {
  name: 'KidScore',
  props: {
    well: {
      type: Object,
      required: true
    },
  },

  computed: {
    ...mapState({
      selectedTenant: state => state.common.selectedTenant
    }),
    ...mapGetters({
      getPnCount: 'timelapse/getPnCount',

    }),
    pnCount() {
      return this.getPnCount(this.well)
    },


    inferenceData() {
      return this.well.inferenceData
    },

    blastScoreText() {
      switch (true) {
        case this.blastScore > 0.8:
          return 'High'
        case this.blastScore > 0.5:
          return 'Medium+'
        case this.blastScore > 0.3:
          return 'Medium-'
        default:
          return 'Low'
      }
    },

    blastScore() {
      return this.inferenceData.blastScore
    },

    blastScoreColor() {
      switch (true) {
        case this.blastScore > 0.8:
          return 'rag-green'
        case this.blastScore > 0.3:
          return 'rag-amber'
        default:
          return 'rag-red'
      }
    },
    houre() {
      return this.well.videoFramesTime.slice(-1) / 1000 / 60 / 60
    },
    showScore() {
      return this.pnCount == 2 && this.houre >= DEFAULT_BLAST_AT_HOUR
    },
    noScoreText() {
      return (this.houre < DEFAULT_BLAST_AT_HOUR || this.pnCount == null) ? 'Pending' : 'Non-viable'
    }
  },


}
</script>

<style lang="scss" scoped>
.kid-score {
  // relevant to all options
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;
  border-radius: $border-radius;


  &.na_score {
    background-color: $dark-4;

    .label {
      font-weight: 400;
    }
  }


  &.well-card-option {


    .label {
      padding: 0 2px;
      font-size: 11.5px;
      font-weight: 600;
    }


    &.rag-green {
      border: 0.1rem solid $green;

      span {
        color: $dark-4 !important;
      }
    }

    &.rag-red {
      border: 0.1rem solid $red;

      span {
        color: $dark-4 !important;
      }
    }

    &.rag-amber {
      border: 0.1rem solid $orange;

      span {
        color: $dark-4 !important;
      }
    }
  }
}
</style>
